import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "m-0 text-sm font-bold text-textPrimary" }, "Registrar contato", -1)
const _hoisted_3 = { class: "m-0 text-xs text-neutral50" }
const _hoisted_4 = { class: "flex flex-col gap-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-[11px] uppercase tracking-wider text-neutral50" }, "Canal", -1)
const _hoisted_6 = { class: "flex flex-wrap gap-1" }
const _hoisted_7 = ["aria-pressed", "data-testid", "onClick"]
const _hoisted_8 = { class: "flex flex-col gap-1" }
const _hoisted_9 = ["for"]
const _hoisted_10 = ["id", "maxlength", "data-testid"]
const _hoisted_11 = ["data-testid"]
const _hoisted_12 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_13 = ["disabled", "data-testid"]
const _hoisted_14 = ["disabled", "data-testid"]

import { ref } from 'vue'

import type { PriorityContactChannel } from '@/Network/Types/Responses/PriorityPaymentsResponses'

import { PRIORITY_CONTACT_CHANNEL_LABELS, PRIORITY_CONTACT_NOTE_MAX_LENGTH } from '../constants'


export default /*#__PURE__*/_defineComponent({
  __name: 'PriorityContactForm',
  props: {
    doctorStationId: {},
    doctorName: {},
    defaultChannel: { default: 'WHATSAPP' },
    isSaving: { type: Boolean, default: false },
    testId: { default: 'priority-contact-form' }
  },
  emits: ["submit", "cancel"],
  setup(__props: any, { emit }) {

const props = __props;





const channel = ref<PriorityContactChannel>(props.defaultChannel)
const note = ref('')

/**
 * Observação em branco NÃO vira `note: ''`: o contrato a trata como ausente, e
 * gravar string vazia encheria o histórico de cobrança de linhas que parecem ter
 * anotação e não têm.
 */
function onSubmit(): void {
  const trimmed = note.value.trim()
  emit('submit', {
    doctorStationId: props.doctorStationId,
    channel: channel.value,
    ...(trimmed ? { note: trimmed } : {})
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "flex flex-col gap-3 rounded-lg border border-lightGray30 bg-white p-3.5",
    "data-testid": _ctx.testId
  }, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.doctorName) + " · #" + _toDisplayString(_ctx.doctorStationId), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PRIORITY_CONTACT_CHANNEL_LABELS), (label, value) => {
          return (_openBlock(), _createElementBlock("button", {
            key: value,
            type: "button",
            class: _normalizeClass(["rounded-full border px-2.5 py-1 text-[13px]", 
            channel.value === value
              ? 'border-primary bg-primary text-white'
              : 'border-lightGray30 bg-white text-neutral50'
          ]),
            "aria-pressed": channel.value === value,
            "data-testid": `${_ctx.testId}-channel-${value}`,
            onClick: ($event: any) => (channel.value = value)
          }, _toDisplayString(label), 11, _hoisted_7))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("label", {
        class: "text-[11px] uppercase tracking-wider text-neutral50",
        for: `${_ctx.testId}-note`
      }, " Observação (opcional) ", 8, _hoisted_9),
      _withDirectives(_createElementVNode("textarea", {
        id: `${_ctx.testId}-note`,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((note).value = $event)),
        rows: "2",
        maxlength: _unref(PRIORITY_CONTACT_NOTE_MAX_LENGTH),
        class: "w-full rounded-md border border-lightGray30 px-2 py-1 text-[13px] text-textPrimary",
        "data-testid": `${_ctx.testId}-note`
      }, null, 8, _hoisted_10), [
        [_vModelText, note.value]
      ]),
      _createElementVNode("span", {
        class: "self-end text-[11px] tabular-nums text-neutral50",
        "data-testid": `${_ctx.testId}-note-counter`
      }, _toDisplayString(note.value.length) + "/" + _toDisplayString(_unref(PRIORITY_CONTACT_NOTE_MAX_LENGTH)), 9, _hoisted_11)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        type: "button",
        class: "rounded-md border border-primary bg-primary px-3 py-1.5 text-sm font-medium text-white",
        disabled: _ctx.isSaving,
        "data-testid": `${_ctx.testId}-submit`,
        onClick: onSubmit
      }, " Registrar contato ", 8, _hoisted_13),
      _createElementVNode("button", {
        type: "button",
        class: "rounded-md border border-lightGray30 px-3 py-1.5 text-sm font-medium text-textPrimary",
        disabled: _ctx.isSaving,
        "data-testid": `${_ctx.testId}-cancel`,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel')))
      }, " Cancelar ", 8, _hoisted_14)
    ])
  ], 8, _hoisted_1))
}
}

})